"use strict";
export default (page) => {
  const types = [
    "invoice",
    "carrierInvoice",
    "factorInvoice"
  ];
  return page && types.indexOf(page.type) >= 0;
};
